export default __webpack_public_path__ + "static/media/TemplateUnidadesBudgetForecast.88d2ffc7.xlsx";